import { formatLocale } from "../../../helpers/formatLocale";

const TARGET_RENTERS = [
  'Tourists & Sightseers',
  'Business Travelers',
  'City Dwellers Without Cars',
  'Students & Young Adults',
  'Emergency Renters'
];

const formatTravelReason = (targetRenters) => {
  if (targetRenters === "Others") {
    return "for personal reasons";
  } else if (targetRenters === 'All') {
    return TARGET_RENTERS.join(', ');
  }
  return targetRenters;
};

export const ownerPrompt = {

  carTitleDescription: ({ location, carFeatures, carDetails, lang, targetRenters }) => {
    const finalReason = formatTravelReason(targetRenters);
    const isAll = targetRenters === 'All';
    return `
  You are an expert rental car copywriter.
  Write one short, catchy title (≤10 words) and one detailed, engaging description (80–120 words) for a rental car listing.
  Details:
  ${location ? `- Location: ${location}` : ''}
  ${carFeatures ? `- Car Features: ${carFeatures}` : ''}
  ${carDetails ? `- Car Details: ${carDetails}` : ''}
  - Target Renters: ${finalReason}
  Language: ${formatLocale(lang)}
  Rules:
  1. Title: ≤10 words, catchy, highlight the best feature.
  2. Description: 80–120 words, friendly and engaging.
  3. Mention only available details (location, carFeatures, carDetails).
  4. ${isAll
        ? `The car appeals to ALL renter types (${finalReason}). Write a universally appealing title and description that resonates across all these audiences.`
        : `Tailor the tone specifically for: ${finalReason}. Choose a tone that fits — professional, casual, luxury, family, or business.`
      }
  5. Do not invent or assume extra info.
  6. Output only JSON: { "title": "...", "description": "..." }
    `;
  },


  carRentPriceEstimation: ({ location, carType, make, model, year, carFeatures, currency }) => {
    const featuresText = carFeatures && carFeatures.trim() ? carFeatures : 'Not specified';
    return `You are a car rental pricing expert.
Estimate a realistic daily rental price range for the following car:
- Location: ${location || 'Not specified'}
- Type: ${carType || 'Not specified'}
- Make: ${make || 'Not specified'}
- Model: ${model || 'Not specified'}
- Year: ${year || 'Not specified'}
- Features: ${featuresText}

PRICING GUIDELINES:
1. Price ranges by car type (daily rates):
   - Economy/Compact: 25-60
   - Mid-size/Sedan: 40-90
   - Full-size/Luxury: 70-150
   - SUV/Crossover: 60-130
   - Sports/Performance: 100-250
   - Premium/Luxury: 150-400

2. Price adjustments:
   - Newer models (2020+): +15-25% to base range
   - Older models (2015-2019): -10-15% from base range
   - Very old models (pre-2015): -20-30% from base range
   - Premium features (GPS, leather, sunroof): +10-20% to base price
   - High-demand locations: +10-25% to base price

3. Min/Max relationship constraints:
   - max_price must be 1.4x to 2.0x of min_price (never less than 1.4x, never more than 2.0x)
   - Both prices must be rounded to nearest 5 or 10 (e.g., 45, 50, 55, 60, not 47.50)
   - Prices should reflect realistic market variation for similar vehicles

4. Examples of realistic ranges:
   - Economy car in average location: 30-55
   - Mid-size sedan in popular area: 50-85
   - Luxury SUV in premium location: 120-200

Return ONLY a JSON object in the format:
{
  "min_price": number,
  "max_price": number,
  "currency": "${currency}"
}

Do not include any text, explanation, or formatting outside the JSON object.
Ensure max_price is between 1.4x and 2.0x of min_price. Round all prices to nearest 5 or 10.`;
  }
}
